import request from "@/utils/request.js";
// let path = "/api";
const ContactInformation = {
  /**
   * 查询
   * @param page @type  Number 页码
   * @param pageSize @type Number 条数
   */
  queryList: async (data) => {
    return await request("post", "/record-center/connect/list", data);
  },
  /**
   * 添加或修改
   * @param id @type String 新增不要 修改必传
   * @param area @type  String 所属区域
   * @param chargePerson @type  String 负责人姓名
   * @param contactInformation @type  String 联系方式
   * @param enabled @type Number 是否启用 ENABLE("启用", 1),DISABLE("禁用", 0);
   * @param delStatus @type Number 条数 0未删除 1删除
   * @param createTime @type String 创建时间
   */
  addOrUpDateList: async (data) => {
    return await request("post", "/record-center/connect/add", data);
  },

  /**
   * 删除
   * @param id @type String 删除id
   */
  delList: async (data) => {
    return await request("get", "/record-center/connect/logic-del", data);
  },
};
export default ContactInformation;



// WEBPACK FOOTER //
// ./src/api/contactInformation.js